import { FormControl, UntypedFormGroup } from '@angular/forms';
import { ApplicantView } from './applicant-view';
import { Person } from '@app/core/stingray-api/models';

export class ShareholderView extends ApplicantView {
  search: UntypedFormGroup;
  isSaving: boolean;
  person: Person;
  shareholderId: string;
  shareholderForm: UntypedFormGroup;
  isTaxPartnerApplicantControl: FormControl;


  isValid(): boolean {
    return this.form && this.form.valid && this.shareholderForm && this.shareholderForm.valid;
  }
}
